import type { ProgramType } from '../../interfaces/CamProgramming.interface';

export const PROGRAM_FILENAME_HINT =
	'Exact program filename as saved in Fusion 360 or on the Keyence machine — ' +
	'for example 6198M1004 or 6198M1004 - OPTION 2. CAM and Keyence programs ' +
	'use this to distinguish multiple options for the same part.';

export const KEYENCE_FILENAME_HINT =
	'Pick a name from the inspection plan suggestions or type your own Keyence ' +
	'program filename.';

export const PROGRAMMING_DURATION_HINT =
	'Total minutes spent programming this part. Enter manually when logging ' +
	'after the fact, or start the timer before you begin and the duration is ' +
	'recorded when you mark the program complete.';

export const REVIEW_DURATION_HINT =
	'Total minutes spent on this review. Enter manually when logging after the ' +
	'fact, or start the timer and the duration is recorded when you mark the ' +
	'review complete.';

export const programFilenameHint = (
	programType: ProgramType,
	isEdit = false
) =>
	programType === 'keyence' && !isEdit
		? KEYENCE_FILENAME_HINT
		: PROGRAM_FILENAME_HINT;
